<template>
  <div class="rightCenter">
    <div class="title" :class="menuItem.warehousingGoodsRank ? 'setCursor' : ''" @click="showModel">仓储</div>
    <div class="list">
      <div class="item">
        <img class="icon" src='@/assets/images/home/icon-qysl.png'/>
        <div class="text">当前库存总数</div>
        <div class="num">{{summary.availableQty || 0 | formatNumber}}<span>个</span></div>
      </div>
      <div class="item">
        <img class="icon" src='@/assets/images/home/icon-qysl.png'/>
        <div class="text">货物总金额</div>
        <div class="num">{{summary.totalPrice || 0 | formatNumber}}<span>万</span></div>
      </div>
    </div>
    <!-- <div class="title2">
       <div>交易量TOPS</div>
    </div> -->
    <div id="rightCenter-charts"></div>
  </div>
</template>

<script>
import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import apiPath from '@config/api.json'
const {mapState, mapMutations} = require('vuex')
export default {
  components: {},

  data () {
    return {
      menuItem: {
        warehousingGoodsRank: false // 仓储货物数量/金额TOP排名
      },
      summary: {},
      topPriceSummary: [],
      topQuantitySummary: [],
      myChart: null, // 图表对象
      initObj: null // 用于定时器处理
    }
  },

  ccomputed: {
    ...mapState({
      homeTime: (state) => {
        return state.home.homeTime
      }
    })
  },

  watch: {
    homeTime: function (n) {
      this.init()
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.warehousingGoodsRank = common.isShowItem('warehousingGoodsRank', setListMenu)
    }
  },

  mounted () {
    this.myChart = this.$echarts.init(document.getElementById('rightCenter-charts'))
    this.init()
    this.initObj = setInterval(() => {
      this.init()
    }, 60000)
  },

  methods: {
    ...mapMutations(['setModelInfo']),
    init () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.home.rightCenter.getOrgGoodsStored}`,
        data: {
          pageNum: 1,
          pageSize: 10,
          yearTime: this.homeTime
        }
      }).then(res => {
        if (res && res.data) {
          let dataInfo = res.data || {}
          this.summary = dataInfo
          this.summary.totalPrice = (dataInfo.totalPrice / 10000).toFixed(2)
          this.topPriceSummary = dataInfo.list || []
          this.topQuantitySummary = dataInfo.list || []
        }
        this.initCharts()
      })
    },
    showModel () {
      if (!this.menuItem.warehousingGoodsRank) return
      let that = this
      this.setModelInfo({
        modelUrl: 'listStorageStatistic',
        method: 'post',
        title: '仓储货物数量/金额TOP排名',
        headList: [
          {
            name: '库存总数',
            value: that.summary.availableQty || '0',
            unit: '（件）'
          }, {
            name: '货物总金额',
            value: that.summary.totalPrice || '0',
            unit: '（万）'
          }
        ],
        model: true
      })
    },
    initCharts () {
      this.myChart && this.myChart.clear()
      let companyNameArr = this.topPriceSummary.map(item => { return item.warehouseOrgName.length > 4 ? item.warehouseOrgName.slice(0, 4) + '...' : item.warehouseOrgName })
      // this.topPriceSummary.forEach(item => {
      //   if (item.companyName.length < 4) {
      //     item.company = item.companyName.slice(0,4) + '...'
      //   } else { item.company = item.companyName }
      // })
      let data1 = this.topPriceSummary.map(item => { return item.totalPrice })
      let data2 = this.topQuantitySummary.map(item => { return item.availableQty })
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        // legend: {
        //   data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
        // },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        legend: {
          name: ['交易额', '订单数量'],
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '2%',
          right: '6%',
          bottom: '0%',
          top: '15%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: companyNameArr,
            // data: ['Top1', 'Top2', 'Top3', 'Top4', 'Top5'],
            axisLabel: {
              textStyle: {
                color: '#ffffff'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#ffffff'
              }
            }
          },
          {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#ffffff'
              }
            }
          }
        ],
        series: [
          {
            name: '金额',
            type: 'line',
            stack: 'Total',
            smooth: true,
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: data1
          },
          {
            name: '数量',
            type: 'line',
            stack: 'Total',
            yAxisIndex: 1,
            smooth: true,
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            label: {
              show: true,
              position: ['50%', '50%'],
              // position: [10,0],
              textStyle: {
                color: '#ffffff'
              }
            },
            data: data2
          }
        ]
      }
      option && this.myChart.setOption(option)
    }
  },
  beforeDestroy () {
    clearInterval(this.initObj)
  }
}
</script>

<style lang="scss" scoped>
  .rightCenter{
    width: 454px;
    height: 281px;
    background: url('~@/assets/images/home/title-bg.png') no-repeat 0 0;
    background-size:100% 100%;
    .title{
      height: 18px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #00FAFF;
      width: 100%;
      line-height: 18px;
      margin-top: 16px;
      text-align: center;
    }
    .list{
      display: flex;
      justify-content: space-between;
      margin:16px 30px 0 30px;
      .item{
        display: flex;
        align-items: center;
        .icon{
          width: 34px;
          height:34px;
        }
        .text{
          font-size:10px;
          margin-right:10px;
        }
        .num{
          font-size:14px;
          // color:#30FDFF;
          span{
            font-size:10px;
          }
        }
      }
    }
    .title2{
      background: url('~@/assets/images/home/rightCenter-line.png') no-repeat 0 0;
      background-size:100% 100%;
      // width: 66px;
      height: 18px;
      width: 398px;
      margin-left:24px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #F2F2F2;
      line-height: 8px;
      margin-top: 5px;
      div{
        padding-top:6px;
        padding-left: 42px;
      }
    }
    #rightCenter-charts{
      margin:0px 18px 0 18px;
      width:420px;
      height:172px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/compontents/rightCenter.vue